import { SEATING_STRATEGY_TYPE, SeatingStrategyBase } from "./seating-strategy";

export class SeatingStrategyPreferHighTableCapacityUsage extends SeatingStrategyBase {
  constructor(scorePerUnusedSeatMultiplier, policyLevel) {
    super(SEATING_STRATEGY_TYPE.PreferHighTableCapacityUsage, 0, 0, policyLevel);

    this.scorePerUnusedSeatMultiplier = scorePerUnusedSeatMultiplier;
  }

  static defaultValue = -20;

  toString() {
    return `${SEATING_STRATEGY_TYPE.nameof(this.seatingStrategyType)} (Multiplier per unmatched seat: ${this.scorePerUnusedSeatMultiplier})`;
  }

  isValid() {
    return true;
  }

  static fromJSON(json){
    if(!json) return undefined;

    return Object.assign(new SeatingStrategyPreferHighTableCapacityUsage(), json);
  }
}


